module.exports = __webpack_public_path__ + "static/media/home-carousel9.f2517290.webp";